// Captura los parámetros de campaña (Google Ads / Meta Ads) presentes en la URL
// y los convierte en tags de Tokko, para poder atribuir los leads por campaña.

const UTM_TAG_LABELS: Record<string, string> = {
  utm_source: 'Origen: ',
  utm_medium: 'Pieza: ',
  utm_campaign: 'Campaña: ',
  utm_content: 'Anuncio: ',
  utm_term: 'Término: ',
  gclid: 'Google Click ID: ',
  fbclid: 'Meta Click ID: ',
}

export const getUtmTags = (): string[] => {
  if (typeof window === 'undefined') return []

  const params = new URLSearchParams(window.location.search)
  const tags: string[] = []

  Object.keys(UTM_TAG_LABELS).forEach((key) => {
    const value = params.get(key)
    if (value) {
      tags.push(UTM_TAG_LABELS[key] + value)
    }
  })

  return tags
}
